<template>
  <component :is="tag" class="list-item" :class="['list-item--' + type]" v-bind="$attrs" v-on="$listeners">
    <div class="list-item__header">
      <div class="list-item__title">
        <slot name="title">{{ title }}</slot>
        <div class="list-item__title--new" v-if="isNew" v-tooltip="$t('new')"></div>
      </div>
      <div class="list-item__badges">
        <Badge :theme="badge">
          <slot name="type">{{ $tc('badge-' + type) }}</slot>
        </Badge>
      </div>
    </div>
    <div class="list-item__details">
      <div class="list-item__details-wrapper">
        <slot name="details" />
        <div v-if="datetime || $slots.datetime" class="list-item__datetime">
          <slot name="datetime">
            <FontAwesomeIcon :icon="['fal', 'calendar']" />
            {{ datetime }}
          </slot>
        </div>
      </div>
    </div>
    <slot></slot>
  </component>
</template>

<script>
import Badge from '@/components/Badge'
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    isNew: Boolean,
    type: String,
    title: String,
    datetime: String,
  },
  computed: {
    badge() {
      switch (this.type) {
        case 'lead':
          return 'warning'
        case 'openhouse':
        case 'task':
        case 'formsubmit':
          return 'primary'
        case 'bid':
        case 'shopcontract':
        case 'purchase':
        case 'customcontract':
          return 'error'
        default:
          return 'default'
      }
    },
  },
  components: {
    Badge,
  },
}
</script>

<style lang="scss">
.list-item {
  border-radius: var(--border-radius);
  padding: 0.5rem 0;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-decoration: none;
  color: inherit;

  & + & {
    border-top: 1px solid css-alpha('border-color', 0.5);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 0.5rem;
  }

  &__title {
    line-height: 1.2;

    > * {
      color: inherit;
    }

    &--new {
      width: 0.5rem;
      aspect-ratio: 1;
      background-color: var(--error);
      border-radius: 20rem;
      display: inline-block;
      margin-left: 0.25rem;
    }
  }

  &__badges {
    display: flex;
    gap: 0.25rem;

    .badge {
      padding: 0 5px;
    }
  }

  &__details {
    width: 100%;
    font-size: 0.8em;

    &-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0 0.5rem;

      .avatar {
        order: 1;
      }

      .list-item__datetime {
        order: 2;
      }

      & > * {
        order: 100;
        &:not(.list-item__detail--no-fade) {
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
